import React, { useState } from "react";
import axios from "axios";
import "./AddDetails.css";

const AddDetails = () => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    file: null,
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, file: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append("title", formData.title);
    formDataToSend.append("description", formData.description);
    formDataToSend.append("file", formData.file);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/details/addourdetails`, formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      // console.log(response.data);
      alert("Data added successfully!");
 setFormData(
 { title: "",
  description: "",
  file: null,}
 )
      
    } catch (error) {
      console.error("Error adding details:", error);
      alert("Failed to add details");
    }
  };

  return (
    <div className="add-details-container">
      <h2>Add Details</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="title">Title</label>
          <input id="title" name="title" type="text" value={formData.title} onChange={handleChange} required />
        </div>

        <div className="form-group">
          <label>Upload File</label>
          <input type="file" accept="application/pdf" onChange={handleFileChange} required />
        </div>

        <div className="form-group">
          <label htmlFor="description">Description</label>
          <textarea id="description" name="description" value={formData.description} onChange={handleChange} required />
        </div>

        <button type="submit" className="submit-btn">Submit</button>
      </form>
    </div>
  );
};

export default AddDetails;
